module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAAElh7xMAAAABGdBTUEAALGPC/xhBQAAAL9JREFUKBWNT0sKwjAQbS14Hd3YY/QOLlx4BLsqrb2D4KIgbnpFocT3kkyM4yAdePN5702YFAXCOXdmZeOY5s8U6RslCVoaoAKmkqz3I5XRTmKg7UDViCV3yrbUVhpf4/aoyQnCCdgCM9DQwGsW1M2XOww1SUugfOS1LfATYRkZSp+rSZAG4kiDzKmCu1JQ8cTMy3UMfhHsQysr5jvv3AOvFWax0LvLz+1E+VO7tKAbLFn/Df/SZmvGAxfC0si9AZHZe/FIxHHgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/gz.png
// module id = 4BWU
// module chunks = 1